import React from 'react';
import styled from 'styled-components';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import 'assets/styles/time-picker.css';

const TimeFieldWrapper = styled.div`
  position: relative;
  .rc-time-picker {
    position: relative;
    &:after, &:before {
      content: '';
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid ${p => p.theme.color.label};
      position: absolute;
      right: .7em;
      top: 53%;
    }
    &:before {
      top: 29%;
      z-index: 1;
      transform: rotate(180deg);
    }
  }
  .rc-time-picker-input {
    padding: .8em;
  }
  span {
    width: 100%;
  }
  input {
    font-size: 1em;
    padding: 1.2em 1em;
    height: 2.5em;
    outline: none;
    &.rc-time-picker-panel-input {      
      padding: 0 0.5em;
      font-size: 1.3em;
      height: 2.5em;
    }   
    .rc-time-picker-panel-input-wrap{
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  @media screen and (min-width:0\0) {
    input { 
      padding: 0.3em 1em;
    }
    input::-ms-clear {
      width : 0;
      height: 0;
    }    
    .rc-time-picker-clear{
      display: none;
    }
  }
`;

export default props => (
  <TimeFieldWrapper>
    <TimePicker {...props} getPopupContainer={node => node} />
  </TimeFieldWrapper>
);
